goog.provide("shadow.js.shim.module$date_fns$locale$pt$default");
shadow.js.shim.module$date_fns$locale$pt$default = esm_import$date_fns$locale$pt.default;
